import { ArticlePreview } from "../molecules"

import type { PostModel } from "@serializers/article"

interface PostGridElementProps {
  posts: PostModel[]
}

export function PostGridElement(props: PostGridElementProps) {
  const { posts } = props

  const getPostsElements = () => {
    let index = 0
    let elements: JSX.Element[] = []
    const count = posts.length

    if (count > 1) {
      // 3 cards in a row
      const postsToRender = count === 4 ? posts.slice(0, 3) : posts
      elements = postsToRender.map((post) => (
        <ArticlePreview
          key={post.id}
          article={post}
          classes={{
            container: "desktop-l:h-[709px]",
          }}
        />
      ))
      index = postsToRender.length
    }

    if (count - index === 1) {
      // row with 1 card
      const post = posts[index++]
      elements.push(
        <ArticlePreview
          key={post.id}
          article={post}
          orientation="horizontal"
          classes={{
            container:
              "tablet-s:h-[300px] desktop:h-[441px] tablet-s:col-span-3",
          }}
        />,
      )
    }
    return elements
  }

  return (
    <div className="grid gap-3 tablet-s:grid-cols-3 tablet-s:gap-4 desktop-l:gap-6">
      {getPostsElements()}
    </div>
  )
}
